import { Link } from 'react-router-dom';

export interface Crumb {
  name: string;
  path?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1 text-xs md:text-sm label-font">
      <ol className="flex items-center flex-wrap gap-1">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.name} className="flex items-center gap-1">
              {item.path && !isLast ? (
                <Link
                  to={item.path}
                  className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {item.name}
                </Link>
              ) : (
                <span className="text-foreground-800 whitespace-nowrap" aria-current="page">
                  {item.name}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}